import { useRef } from "react";

// スワイプ検出ラッパー: 水平移動が縦移動より大きく、閾値以上のときだけ発火
export function SwipeWrapper({ onSwipeLeft, onSwipeRight, children }) {
  const start = useRef({ x: 0, y: 0, t: 0, active: false });
  const onTouchStart = (e) => {
    const t = e.touches?.[0];
    if (!t) return;
    start.current = { x: t.clientX, y: t.clientY, t: Date.now(), active: true };
  };
  const onTouchEnd = (e) => {
    const s = start.current;
    if (!s.active) return;
    start.current.active = false;
    const t = e.changedTouches?.[0];
    if (!t) return;
    const dx = t.clientX - s.x;
    const dy = t.clientY - s.y;
    const dt = Date.now() - s.t;
    // 閾値: 水平55px以上、縦移動の1.5倍以上、800ms以内
    if (Math.abs(dx) >= 55 && Math.abs(dx) > Math.abs(dy) * 1.5 && dt < 800) {
      if (dx < 0) onSwipeLeft?.();
      else onSwipeRight?.();
    }
  };
  return (
    <div className="flex-1 flex flex-col min-h-0" onTouchStart={onTouchStart} onTouchEnd={onTouchEnd}>
      {children}
    </div>
  );
}
